import { makeI18nField } from "../utils/i18nSchemas.js";

export const getAllSurveysSchema = {
  querystring: {
    type: "object",
    properties: {
      eventId: { type: "string" },
      page: { type: "integer", minimum: 1 },
      limit: { type: "integer", minimum: 1, maximum: 100 },
    },
    required: ["eventId"],
  },
};

export const getAllQuestionsForSurveySchema = {
  params: {
    type: "object",
    required: ["surveyId"],
    properties: {
      surveyId: { type: "integer" },
    },
  },
};

export const getAllLiveSurveysSchema = {
  querystring: {
    type: "object",
    properties: {
      eventId: { type: "number" },
    },
    required: ["eventId"],
  },
};

export const createSurveySchema = {
  body: {
    type: "object",
    required: ["eventId", "titleI18n"],
    properties: {
      eventId: { type: "integer" },
      titleI18n: makeI18nField({ required: true, minLength: 1 }),
      descriptionI18n: makeI18nField(),
    },
    additionalProperties: false,
  },
};

export const getSurveyByIdSchema = {
  params: {
    type: "object",
    required: ["surveyId"],
    properties: {
      surveyId: { type: "integer" },
    },
  },
};

export const updateSurveySchema = {
  params: {
    type: "object",
    required: ["surveyId"],
    properties: {
      surveyId: { type: "integer" },
    },
  },
  body: {
    type: "object",
    properties: {
      titleI18n: makeI18nField({ required: true, minLength: 1 }),
      descriptionI18n: makeI18nField(),
      isLive: {
        anyOf: [
          { type: "boolean" },
          { type: "string", enum: ["true", "false"] },
        ],
      },
    },
    additionalProperties: false,
  },
};

export const createSurveyQuestionsSchema = {
  params: {
    type: "object",
    required: ["surveyId"],
    properties: {
      surveyId: { type: "integer" },
    },
  },

  body: {
    type: "object",
    required: ["questionTextI18n", "questionType"],
    properties: {
      questionTextI18n: makeI18nField({ required: true, minLength: 1 }),

      questionType: {
        type: "string",
        enum: ["multiple_choice", "single_choice", "text"],
      },

      answerOptions: {
        anyOf: [
          {
            type: "array",
            minItems: 1,
            items: {
              type: "object",
              required: ["labelI18n"],
              properties: {
                labelI18n: makeI18nField({
                  required: true,
                  minLength: 1,
                }),
              },
              additionalProperties: false,
            },
          },
          { type: "null" },
        ],
      },
    },

    additionalProperties: false,

    allOf: [
      {
        if: {
          properties: { questionType: { const: "text" } },
        },
        then: {
          properties: { answerOptions: { type: "null" } },
        },
        else: {
          required: ["answerOptions"],
        },
      },
    ],
  },
};

export const getSurveyQuestionByIdSchema = {
  params: {
    type: "object",
    required: ["surveyId", "questionId"],
    properties: {
      surveyId: { type: "integer" },
      questionId: { type: "integer" },
    },
  },
};

export const patchSurveyQuestionSchema = {
  params: {
    type: "object",
    required: ["surveyId", "questionId"],
    properties: {
      surveyId: { type: "integer" },
      questionId: { type: "integer" },
    },
  },
  body: {
    type: "object",
    properties: {
      questionTextI18n: makeI18nField({ required: true, minLength: 1 }),
      questionType: {
        type: "string",
        enum: ["multiple_choice", "single_choice", "text"],
      },
      answerOptions: {
        anyOf: [
          {
            type: "array",
            minItems: 1,
            items: {
              type: "object",
              required: ["labelI18n"],
              properties: {
                labelI18n: makeI18nField({ required: true, minLength: 1 }),
              },
              additionalProperties: false,
            },
          },
          { type: "null" },
        ],
      },
    },
    additionalProperties: false,
  },
};

export const patchSurveyQuestionOrderSchema = {
  params: {
    type: "object",
    required: ["surveyId"],
    properties: {
      surveyId: { type: "integer" },
    },
  },
  body: {
    type: "array",
    items: {
      type: "object",
      properties: {
        id: { type: "number" },
        order: { type: "number" },
      },
      required: ["id", "order"],
    },
  },
};

export const createSurveyResponsesSchema = {
  params: {
    type: "object",
    required: ["surveyId"],
    properties: {
      surveyId: { type: "integer" },
    },
  },
  body: {
    type: "object",
    required: ["questionId", "answer"],
    properties: {
      questionId: { type: "integer" },
      answer: {
        type: "array",
        items: { type: "string" },
        minItems: 1,
      },
    },
    additionalProperties: false,
  },
};

export const getSurveyResponseByIdSchema = {
  params: {
    type: "object",
    required: ["surveyId", "responseId"],
    properties: {
      surveyId: { type: "integer" },
      responseId: { type: "integer" },
    },
  },
};

export const web_createSurveySchema = createSurveySchema.body;
export const web_updateSurveySchema = updateSurveySchema.body;
export const web_createSurveyQuestionsSchema = createSurveyQuestionsSchema.body;
export const web_patchSurveyQuestionSchema = patchSurveyQuestionSchema.body;
